export default class ZoneCoordGeoController {
	static $inject = ['$scope', '$stateParams', 'notification', 'ModalService', '$uibModal', '$translate'];

	constructor($scope, $stateParams, notification, ModalService, $uibModal, $translate) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.notification = notification;
		this.ModalService = ModalService;
		this.$uibModal = $uibModal;
		this.$translate = $translate;
	}

	annuler() {
		this.modalInstance.close();
	}

	confirmer() {
		this.modalInstance.close(this.zone);
	}

	async $onInit() {
		console.log(this.zone);
	}
}
